module.exports = __webpack_public_path__ + "img/puppy-main-hero.1693bab3.png";